import {Observable} from "rxjs";
import {MarketMakerCoverageUtil} from "../../models/MarketMakerCoverage";

var app = angular.module('tf.stockScreener', [])

    .controller('stockScreenerCtrl', ['$scope', '$http', '$uibModalInstance', 'actionText', function stockScreenerModalController($scope, $http, $uibModalInstance, actionText) {
        $scope.actionText = actionText;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.goToStrategy = function (stock) {
            $uibModalInstance.close(stock.underlying);
        };

    }])

    .controller('stockScreenerBodyCtrl', ['$scope', '$http', '$timeout', '$state', 'watchListStore', function stockScreenerController($scope, $http, $timeout, $state, watchListStore) {

        $scope.priceDates = [];
        $scope.volDates = [];

        const orderWatch = $scope.$watch("order",
            function (newVal) {
                $timeout(function () {
                    $("[masonry]").masonry('reloadItems');
                    $("[masonry]").masonry();
                })
            });
        $scope.$on("$destroy", orderWatch);

        const reverseWatch = $scope.$watch("reverse",
            function (newVal) {
                $timeout(function () {
                    $("[masonry]").masonry('reloadItems');
                    $("[masonry]").masonry();
                })
            });
        $scope.$on("$destroy", reverseWatch);

        $scope.expandAll = function() {
            $scope.stocks.forEach($scope.expandStock);
        };

        $scope.orderStocks = (s1, s2) => {
            const val1 = s1.value;
            const val2 = s2.value;

            if ($scope.order === "coverageLevel" && MarketMakerCoverageUtil.isMarketCoverage(val1)) {
                return MarketMakerCoverageUtil.compare(val1, val2);
            } else if (typeof s1 === "number") {
                return val1 - val2;
            } else {
                return String(val1).localeCompare(String(val2));
            }
        };

        $scope.expandStock = function (stock) {
            stock.isStockExpanded = !stock.isStockExpanded;
            $scope.loadChartData(stock);
        };

        $scope.switchChartType = function(stock, chartType) {
            stock.chartType = chartType;
        };

        $scope.changeSortOrder = function(sortOrder) {
            if ($scope.order === sortOrder) {
                $scope.reverse = !$scope.reverse
            } else {
                $scope.order = sortOrder;
                $scope.reverse = false;
            }
        };

        $scope.order = 'absPriceChangePercent';
        $scope.reverse = false;
        $scope.nameFilter = '';

        $scope.stockFilter = function(stock) {
            return stock.underlying.toUpperCase().indexOf($scope.nameFilter.toUpperCase()) > -1 ||
                    stock.name.toUpperCase().indexOf($scope.nameFilter.toUpperCase()) > -1;
        };

        $scope.tab = 1;

        $scope.setTab = function(newTab){
            $scope.tab = newTab;
        };

        $scope.isSet = function(tabNum){
            return $scope.tab === tabNum;
        };

        const stockData = $http.get('/tradefloor/api/stockscreener').then((response) => response.data);
        const watchList$ = watchListStore.userCodes;

        const sub = Observable.combineLatest(Observable.fromPromise(stockData), watchList$)
                              .map(([stocks, watchlistSecurities]) => {
                                  const watchlistCodes = watchlistSecurities.map((item) => item.code);

                                  stocks.forEach(function(s) {
                                      s.chartType = 'optionsPrice';
                                      s.chartRange = '30d';
                                      s.absPriceChangePercent = -Math.abs(s.priceChangePercent);
                                      s.negPriceChangePercent = -s.priceChangePercent;
                                      s.chartVolatilityOptions = optionsVolatility();
                                      s.chartPriceOptions = s.underlying === 'XJO' ? optionsPricePoints(s) : optionsPrice(s);
                                      s.inWatchList = watchlistCodes.includes(s.underlying);
                                  });

                                  return stocks;
                              })
                              .subscribe((stocks) => {
                                  $scope.$applyAsync(() => $scope.stocks = stocks);
                              });

        $scope.$on("$destroy", () => sub.unsubscribe());


        //    CHARTING

        function optionsPrice(stock) {
            return {
                chart: {
                    type: 'candlestickBarChart',
                    height: 200,
                    width: 400,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 60
                    },
                    x: function(d){ return d['date']; },
                    y: function(d){ return d['close']; },
                    duration: 100,

                    xAxis: {
                        axisLabel: 'Dates',
                        tickFormat: function (d) {
                            switch (stock.chartRange) {
                                case '30d':
                                case '90d':
                                case '1y':
                                case '5y':
                                    return d3.time.format('%d/%m/%y')(new Date($scope.priceDates[d]));
                                default:
                                    return d3.time.format('%d/%m/%y %H:%M')(new Date($scope.priceDates[d]));
                            }
                        },
                        showMaxMin: false
                    },

                    yAxis: {
                        axisLabel: 'Stock Price',
                        tickFormat: function(d){
                            return '$' + d3.format(',.3f')(d);
                        },
                        showMaxMin: false
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };
        }

        function optionsPricePoints(stock) {
            return {
                chart: {
                    type: 'candlestickBarChart',
                    height: 200,
                    width: 400,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 60
                    },
                    x: function(d){ return d['date']; },
                    y: function(d){ return d['close']; },
                    duration: 100,

                    xAxis: {
                        axisLabel: 'Dates',
                        tickFormat: function (d) {
                            switch (stock.chartRange) {
                                case '30d':
                                case '90d':
                                case '1y':
                                case '5y':
                                    return d3.time.format('%d/%m/%y')(new Date($scope.priceDates[d]));
                                default:
                                    return d3.time.format('%d/%m/%y %H:%M')(new Date($scope.priceDates[d]));
                            }
                        },
                        showMaxMin: false
                    },

                    yAxis: {
                        axisLabel: 'Index',
                        tickFormat: function(d){
                            return d3.format(',.1f')(d);
                        },
                        showMaxMin: false
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };
        }

        function optionsVolatility() {
            return {
                chart: {
                    type: 'lineChart',
                    height: 200,
                    width: 400,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 60
                    },
                    showLegend: false,
                    x: function(d){ return d['date']; },
                    y: function(d){ return d['IV30']; },
                    duration: 100,


                    xAxis: {
                        axisLabel: 'Dates',
                        tickFormat: function(d) {
                            return d3.time.format('%d/%m/%y %H:%M')(new Date($scope.volDates[d]));
                        },
                        showMaxMin: false
                    },

                    yAxis: {
                        axisLabel: 'IV 30',
                        tickFormat: function(d){
                            return d3.format(',.3f')(d);
                        },
                        showMaxMin: false
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };
        }

        $scope.loadChartData = function(stock) {
            return $http.get('/tradefloor/api/prices/chart/' + stock.underlying + '?r=' + stock.chartRange).
                then(function(response) {
                $scope.priceDates = [];
                $scope.volDates = [];

                Papa.parse(response.data, {
                    download: false,
                    complete: function (results) {
                        results.data.shift(); // Remove header

                        var iPriceDate = 0;
                        stock.chartPriceData = [{values: results.data.filter(function (row) {
                            return row[0];

                        })
                            .map(function (row) {
                                $scope.priceDates.push(new Date(row[0]));
                                return {
                                    date: iPriceDate++,
                                    open: parseFloat(row[1]),
                                    high: parseFloat(row[2]),
                                    low: parseFloat(row[3]),
                                    close: parseFloat(row[4])
                                }
                            })}];

                        var iVolDate = 0;
                        stock.chartVolatilityData = [{key : 'Volatility', values: results.data.filter(function (row) {
                            return row[0];

                        })
                            .map(function (row) {
                                $scope.volDates.push(new Date(row[0]));
                                return {
                                    date: iVolDate++,
                                    IV30 : parseFloat(row[5]) * 100.0
                                }
                            })}];

                        // Update the options to trigger a full refresh
                        stock.chartPriceOptions = Object.assign({}, stock.chartPriceOptions);
                        stock.chartVolatilityOptions = Object.assign({}, stock.chartVolatilityOptions);
                    }
                });
        });
    };
    }]);




